import { useTranslation } from 'react-i18next';

import {
    Body1,
    Box,
    Modal,
    Stack,
    Subtitle2,
} from '@myphx-engineering/phx-design-system';

export type BenefitCardInfoModalProps = {
    isOpen: boolean;
    close: () => void;
};

export const BenefitCardInfoModal = ({
    isOpen,
    close,
}: BenefitCardInfoModalProps) => {
    const { t } = useTranslation();

    return (
        <Modal
            opened={isOpen}
            onClose={close}
            title={t('planCards.benefit.modal.title')}
        >
            <Stack gap="sm">
                <Box>
                    <Subtitle2>
                        {t('planCards.benefit.modal.whatIsIt.heading')}
                    </Subtitle2>
                    <Body1>{t('planCards.benefit.modal.whatIsIt.body')}</Body1>
                </Box>
                <Box>
                    <Subtitle2>
                        {t('planCards.benefit.modal.isItDifferent.heading')}
                    </Subtitle2>
                    <Body1>
                        {t('planCards.benefit.modal.isItDifferent.body')}
                    </Body1>
                </Box>
            </Stack>
        </Modal>
    );
};
